import { render, staticRenderFns } from "./ReportImageUpload.vue?vue&type=template&id=2c91204b&scoped=true&"
import script from "./ReportImageUpload.vue?vue&type=script&lang=ts&"
export * from "./ReportImageUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c91204b",
  null
  
)

export default component.exports